import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/project/ProjectUIHelpers";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  projectForEdit: null,
  error: null,
  filters: initialFilter,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    projectFetched: (state, action) => {
      state.actionsLoading = false;
      state.projectForEdit = action.payload.projectForEdit;
      state.error = null;
    },
    projectsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    projectCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.project);
    },
    projectUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (entity.id === action.payload.project.id) {
          return action.payload.project;
        }
        return entity;
      });
    },
    projectFilter: (state, action) => {
      state.listLoading = false
      state.error = null
      state.filters = action.payload
    }
  },
});
